import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ANSWERS = { tri: [["sim", "Sim"], ["nao", "Não"], ["nao_sei", "Não sei"]], bool: [[true, "Sim"], [false, "Não"]] };

// Perguntas ao proprietário na mesma página dos documentos (as mesmas do cartão do consultor).
export function PortalQuestions({ token, session, items, onDone }) {
  const [busy, setBusy] = useState(null);
  if (!items.length) return null;
  const answer = async (key, value) => {
    setBusy(key);
    try { await axios.post(`${API}/portal/${token}/question`, { key, value }, { headers: { "X-Portal-Session": session } }); onDone(); }
    finally { setBusy(null); }
  };
  return (
    <div data-testid="portal-questions">
      <h2 className="text-base font-semibold brand-text">{items.length === 1 ? "Uma pergunta sobre o imóvel" : `${items.length} perguntas sobre o imóvel`}</h2>
      <div className="mt-3 space-y-3">
        {items.map((q) => (
          <div key={q.key} className="bg-white rounded-[18px] border border-slate-100 p-4 transition-shadow" data-testid={`portal-question-${q.key}`}>
            <div className="text-[16px] font-semibold text-slate-800">{q.ask}</div>
            <p className="text-sm text-slate-500 mt-1">{q.why}</p>
            <div className="mt-3 flex flex-wrap gap-2">
              {ANSWERS[q.kind].map(([v, l]) => (
                <button key={String(v)} type="button" disabled={!!busy} onClick={() => answer(q.key, v)} data-testid={`portal-question-${q.key}-${String(v)}`}
                  className="px-4 py-2.5 rounded-xl border-2 border-slate-200 text-sm font-semibold text-slate-700 bg-white hover:border-slate-400 transition-colors disabled:opacity-50">{l}</button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
